import React, { useEffect, useState } from "react";
import "./puja-campaign-payment-modal.scss";
import Image from "next/image";

import checkCouponCode from "@/customHooks/campaign/durgaPuja2025/checkCouponCode";
import { initiatePayment } from "@/customHooks/campaign/durgaPuja2025/initiatePayment";

import paymentModalBg from "@/../public/campaign/puja-2025/payment-popup-bg.webp";
import appliedDicountIcon from "@/../public/campaign/puja-2025/applied-discount.png";

export default function PaymentModal({ onNextComp, userId, bgId, gender }) {
  const [inputCoupon, setInputCoupon] = useState("");
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [isValidCoupon, setIsValidCoupon] = useState(false);
  const [couponDetails, setCouponDetails] = useState(null);
  const [totalAmountString, setTotalAmountString] = useState("");
  const [festivalDiscountInPercent, setFestivalDiscountInPercent] =
    useState(20);
  const [isLoading, setIsLoading] = useState(false);
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const [couponError, setCouponError] = useState("");

  // handle check coupon
  const handleCheckCoupon = async () => {
    setIsLoading(true);

    if (!inputCoupon || !inputCoupon.trim()) {
      setIsValidCoupon(false);
      setIsLoading(false);
      setCouponError("Please enter a coupon code");
      return;
    }

    const result = await checkCouponCode(inputCoupon.trim());
    if (!result) {
      setIsValidCoupon(false);
      setIsLoading(false);
      setCouponError("Please enter a valid coupon code");
      return;
    }
    setTimeout(() => {
      setCouponDetails(result?.coupon);
      setIsValidCoupon(true);
      setIsLoading(false);
    }, 2000);
  };

  // calculate total amount
  useEffect(() => {
    const calculateTotalAmount = () => {
      const baseAmount = 100;
      let discountedAmount;

      if (festivalDiscountInPercent) {
        discountedAmount = (baseAmount * festivalDiscountInPercent) / 100;
      }

      if (isValidCoupon && couponDetails?.discountInPercent) {
        discountedAmount =
          discountedAmount +
          (baseAmount * parseInt(couponDetails.discountInPercent)) / 100;
      }

      const totalAmount = baseAmount - discountedAmount;
      const finalString = `${totalAmount}`;
      return finalString;
    };

    const totalAmountString = calculateTotalAmount();
    setTotalAmountString(totalAmountString);
  }, [isValidCoupon, couponDetails]);

  // open payu form in new tab and submit
  const openPayUFormHTMLInNewTab = (formHtmlString) => {
    const newWindow = window;

    if (!newWindow) {
      alert("Popup blocked! Please allow popups for this site.");
      return;
    }

    newWindow.document.open();
    newWindow.document.write(formHtmlString);
    newWindow.document.close();

    const maxRetries = 20;
    let attempts = 0;

    const interval = setInterval(() => {
      try {
        const form = newWindow.document.querySelector("form");

        if (form) {
          form.submit();
          clearInterval(interval);
        } else if (attempts > maxRetries) {
          clearInterval(interval);
          newWindow.close();
          alert("Payment form not found.");
        }

        attempts++;
      } catch (err) {
        clearInterval(interval);
      }
    }, 100);
  };

  // open payu form in new tab
  const handlePayment = async () => {
    const data = {
      userId,
      bgId,
      gender,
      isFestivalDiscount: festivalDiscountInPercent ? true : false,
      couponCode: couponDetails?.code,
    };

    setIsPaymentLoading(true);

    const result = await initiatePayment(data);

    const paymentData = result?.paymentData;

    if (paymentData && paymentData.includes("<form")) {
      openPayUFormHTMLInNewTab(paymentData);
      setIsPaymentLoading(false);
    } else {
      console.warn("Invalid payment data");
    }
  };

  // applied discount ui
  const AppliedDiscountUi = () => {
    return (
      <span className="flex-row-center appliedDiscount">
        <Image
          src={appliedDicountIcon}
          alt="applied discount icon"
          className="appliedDiscountIcon"
          width={24}
          height={24}
        />
        Applied
      </span>
    );
  };

  return (
    <div className={`flex-row-center PujaCampaignPaymentModal`}>
      <div className="flex-col-center paymentModalContent">
        <Image
          src={paymentModalBg}
          alt="payment-modal-bg"
          width={720}
          height={720}
          style={{ backgroundColor: "#f1f1f1" }}
        />
        <div className="flex-col-center discountsContainer">
          <span className="totalPrice">
            Price : <strong>₹100</strong>
          </span>
          {/* default discount */}
          <div className="flex-row-center defaultDiscount">
            <span className="discountTxt">Special Offer - 20% off</span>
            <AppliedDiscountUi />
          </div>

          {/* coupon code */}
          <div className="flex-row-center couponCodeWrapper">
            <div className="flex-row-center couponCode">
              <input
                type="text"
                placeholder="Have a coupon code ?"
                className="couponInput"
                value={inputCoupon}
                onChange={(e) => {
                  setCouponError("");
                  setCouponDetails(null);
                  setInputCoupon(e.target.value.toLocaleUpperCase());
                  inputCoupon.trim() !== e.target.value.trim() &&
                    setIsValidCoupon(false);
                }}
              />
              {isValidCoupon ? (
                <AppliedDiscountUi />
              ) : (
                <span
                  className="flex-row-center applyCoupon"
                  onClick={handleCheckCoupon}
                >
                  {isLoading ? "Applying.." : "Apply"}
                </span>
              )}
            </div>

            {!couponDetails && (
              <span className="couponError">
                {couponError ? couponError : "Use coupon code to get 50% off"}
              </span>
            )}
          </div>

          {/* total amount and pay*/}
          <button className="flex-row-center payNowBtn">
            <span className="totalAmount">
              Total Amount: <strong>₹{totalAmountString}</strong>
            </span>
            <span className="payNowText" onClick={handlePayment}>
              {isPaymentLoading ? "Processing.." : "Pay Now"}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
